import React from "react";
import "./ButtonContact.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function ButtonContactFooter({ Text, Path }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <Link to={Path} className="Contact_Text">
      <button className={`Contact_ButtonFooter ${isArabic ? "arabic" : "english"}`}>{Text}</button>
    </Link>
  );
}
